<template>
    <div class="px-8">
      <v-overlay absolute :value="downloading" color="white" opacity="0.3" z-index="9">
            <v-progress-circular indeterminate color="#1DBC97" size="100" width="8"></v-progress-circular>
        </v-overlay>
      <v-row class="row-page-hcdash mt-7">
        <v-col align-self="center" cols="12" md="auto" lg="auto" class="pl-0 pt-0">
          <b class="font-header-hcdash">Dashboard: {{company_name}}</b>
        </v-col> <v-spacer></v-spacer>
        <v-col align-self="center" cols="auto" md="auto" lg="auto" class="padding-header-hcdash pt-0">
          <v-btn height="40" depressed class="rounded-lg pa-2 btn-bg-export" color="#1DBC97" @click="exportHcDashboard()">
            <v-icon small class="mr-2" color="#1DBC97">mdi-download</v-icon>
              <span class="font-expoet-hcdash">EXPORT EXCEL</span>
          </v-btn>
        </v-col> 
        <v-col v-show="is_manager_account_id" align-self="center" cols="auto" md="auto" lg="auto" class="padding-header-hcdash pt-0">
          <v-btn height="40" depressed class="rounded-lg pa-2 btn-bg-export" color="#1DBC97" @click="addPermission()">
            <v-icon small class="mr-2" color="#1DBC97">mdi-account-plus-outline</v-icon>
              <span class="font-expoet-hcdash">เพิ่มสิทธิ์การใช้งาน</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="row-page-hcdash mt-0" justify="end">
        <v-col v-show="is_manager_account_id" align-self="center" cols="auto" md="auto" lg="auto" class="px-0 pt-0 aaa" >
          <v-btn height="40" depressed class="rounded-lg pa-2 btn-bg-export" color="#1DBC97" @click="addDoctype()">
            <v-icon small class="mr-2" color="#1DBC97">mdi-file-document-outline</v-icon>
              <span class="font-expoet-hcdash">ลงทะเบียนประเภทเอกสาร</span>
          </v-btn>
        </v-col>
        <v-spacer class="display-pc-only"></v-spacer>
        <v-col v-show="button_select_biz" cols="12" md="3" lg="3" align-self="center" class="pd-select-dashboard pt-0">
            <v-select dense  hide-details flat height="40"
             placeholder="เลือกบริษัท"
             :menu-props="{ bottom: true, offsetY: true }" solo
             color="#1DBC97"
              background-color="white" append-icon="mdi-chevron-down" 
              :items="allhcdashboard"
              item-text="remark"
              item-value="tax_id"
              class=" text-box-hcdashboard-select "
              clearable
              @change="setBiz"
              @click:clear="clearSelect">
              ></v-select>
        </v-col>
        <v-col align-self="center" cols="12" md="3" lg="3"  class="padding-date-hcdash pt-0">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"  
              :return-value.sync="date"
              offset-y
              max-width="290"
              nudge-top="-8"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateText"
                  v-on="on"
                  readonly
                  dense solo flat hide-details color="#9a9a9a" height="40"
                  class="rounded-lg font-date-hcdash" background-color="white"
                  append-icon="mdi-chevron-down"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" range no-title show-current :max="currentdate" color="#1DBC97">
                <v-spacer></v-spacer>
                <v-btn height="32" outlined color="#1DBC97" class="rounded-lg font-cleacon-hcdash" @click="menu = false,clearDateAllDocument()">
                  Clear
                </v-btn>
                <v-btn height="32" :disabled="date.length < 2" depressed color="#1DBC97" class="white--text rounded-lg font-cleacon-hcdash" @click="$refs.menu.save(date),changeDate(),countHcDashboard(),amount_paid(),amount_waitpaid(),countReportHcDashboard()">
                  Confirm
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
      </v-row>
      <v-row class="row-page-hcdash mt-0 mb-4">
        <b class="font-subti-hcdash">All Document</b>
      </v-row>
      <v-row class="row-page-hcdash">
        <v-col cols="12" md="6" lg="6" class="pl-0 py-0 padding-right-first">
          <v-card class="border-radius-cardall pa-2 border-radius-alldoc" color="#FFFFFF" elevation="0">
            <v-row class="row-page-hcdash">
            <v-col cols="12" md="4" lg="4" class="py-0 pl-0 padding-right-total">
              <v-card height="192" class="pb-0 pl-3 pr-3 pt-3 card-border-color-total" elevation="0">
                <v-row align="center" justify="start" class="row-page-hcdash">
                  <img width="48px" height="48px" src="../../assets/checklist.png">
                  <b class="ml-2 font-card-alldoctotal-hcdash">Total</b>
                </v-row>
                <v-row justify="center" class="row-page-hcdash margin-top-numtotal">
                  <b class="font-card-numtotala-hcdash">{{all_count}}</b>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" lg="4" class="pb-0 padding-left-right-process padding-top-processa">
              <v-card height="192" class="pb-0 pl-2 pr-1 pt-5 card-border-color-process-a" elevation="0" @click='modalnormal("review")'>
                <v-row align="center" justify="start" class="row-page-hcdash font-card-title-processa-hcdash">
                  <b>On Process (A)</b>
                </v-row>
                <v-row justify="center" class="row-page-hcdash magin-top-numprocessa">
                  <b class="font-card-numtotala-hcdash">{{review_count}}</b>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" lg="4" class="pb-0 pr-0 padding-box-left-total">
              <v-row class="row-page-hcdash mb-2">
                  <v-card class="pb-2 pl-4 pr-4 pt-5 card-border-color-approved" elevation="0" @click='modalnormal("approved")'>
                    <v-row align="center" justify="start" class="row-page-hcdash font-card-title-processa-hcdash">
                      <b>Approved</b>
                    </v-row>
                    <v-row justify="center" class="row-page-hcdash mt-3">
                      <b class="font-card-numalldoc-hcdash">{{approve_count}}</b>
                    </v-row>
                  </v-card>
              </v-row>
              <v-row class="row-page-hcdash">
                <v-col cols="6" md="6" lg="6" class="py-0 pl-0 pr-1">
                  <v-card class="pb-0 pl-2 pr-2 pt-1 card-border-color-cancelreject" elevation="0" @click='modalnormal("cancel")'>
                    <v-row align="center" justify="start" class="row-page-hcdash font-canreject-hcdash">
                      <b>Cancel</b>
                    </v-row>
                    <v-row justify="center" class="row-page-hcdash">
                      <b class="font-numcanreject-hcdash">{{cancel_count}}</b>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="6" md="6" lg="6" class="py-0 pr-0 pl-1">
                  <v-card class="pb-0 pl-2 pr-2 pt-1 card-border-color-cancelreject" elevation="0" @click='modalnormal("reject")'>
                    <v-row align="center" justify="start" class="row-page-hcdash font-canreject-hcdash">
                      <b>Rejected</b>
                    </v-row>
                    <v-row justify="center" class="row-page-hcdash">
                      <b class="font-numcanreject-hcdash">{{reject_count}}</b>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" lg="6" class="pr-0 py-0 padding-right-second">
          <v-card class="border-radius-cardall pa-2 border-radius-alldoc" color="#FFFFFF" elevation="0">
            <v-row class="row-page-hcdash">
            <v-col cols="12" md="4" lg="4" class="py-0 pl-0 padding-right-total">
              <v-card min-height="192" class="pb-0 pl-1 pr-1 pt-5 card-border-color-pay" elevation="0" @click='modalnormal("paid")'>
                <v-row align="center" justify="start" class="pl-4 row-page-hcdash font-card-alldoctotal-hcdash">
                  <b>จ่ายแล้ว</b>
                </v-row>
                <v-row justify="center" class="row-page-hcdash margin-top-numpaid">
                  <b class="font-card-processb-hcdash">{{paid_count}}</b>
                </v-row>
                <v-row justify="center" class="row-page-hcdash mt-4 mb-2">
                  <v-col cols="auto" md="auto" lg="auto" class="pa-0">
                    <v-card flat class="border-cardincard1-hcdash px-1">
                      <b class="font-totalpay-hcdash">Total Value: {{total_paid}} บาท</b>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" lg="4" class="pb-0 padding-left-right-process padding-top-processa">
              <v-card min-height="192" class="pb-0 pl-1 pr-1 pt-5 card-border-color-process-p" elevation="0" @click='modalnormal("wait_paid")'>
                <v-row align="center" justify="start" class="pl-1 row-page-hcdash font-card-title-processa-hcdash">
                  <b>On Process (P)</b>
                </v-row>
                <v-row justify="center" class="row-page-hcdash margin-top-numprocessp">
                  <b class="font-card-processb-hcdash">{{wait_paid_count}}</b>
                </v-row>
                <v-row justify="center" class="row-page-hcdash mt-4 mb-2">
                  <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pa-0">
                    <v-card flat class="border-cardincard2-hcdash px-1">
                      <b class="font-totalpay-hcdash">Total Value: {{total_waitpaid}} บาท</b>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" lg="4" class="pb-0 pr-0 padding-box-left-total">
              <v-row class="row-page-hcdash mb-2">
                  <v-card class="pb-0 pl-4 pr-4 pt-3 card-border-color-confirmpay" elevation="0" @click='modalnormal("accept")'>
                    <v-row align="center" justify="start" class="row-page-hcdash font-card-title-processa-hcdash">
                      <b>ยืนยันรับเงิน</b>
                    </v-row>
                    <v-row justify="center" class="row-page-hcdash">
                      <b class="font-card-numalldoc-hcdash">{{accept_count}}</b>
                    </v-row>
                  </v-card>
              </v-row>
              <v-row class="row-page-hcdash">
                  <v-card class="pb-0 pl-4 pr-4 pt-3 card-border-color-cancelpay" elevation="0" @click='modalnormal("decline")'>
                    <v-row align="center" justify="start" class="row-page-hcdash font-card-title-processa-hcdash">
                      <b>ปฏิเสธรับเงิน</b>
                    </v-row>
                    <v-row justify="center" class="row-page-hcdash">
                      <b class="font-card-numalldoc-hcdash">{{decline_count}}</b>
                    </v-row>
                  </v-card>
              </v-row>
            </v-col>
          </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="row-page-hcdash mt-3">
        <v-col cols="12" md="6" lg="6" class="pl-0 py-0 padding-right-first">
          <v-card class="border-radius-cardall pt-2 pb-3 px-3 border-radius-process" color="#FFFFFF" elevation="0">
            <v-row class="row-page-hcdash font-on-process">
              <b class="mr-1">On Process (A)</b>Waiting Performance Approval Status
            </v-row>
            <v-row class="row-page-hcdash">
              <v-col cols="12" md="4" lg="4" class="pl-0 pt-0 padding-card-process-waiting-an">
                <v-card elevation="0" class="pl-3 pt-2 pb-0 pr-3 hov-hcdash card-border-color-process-anml" @click='modalnormal("green")'>
                  <v-row class="row-page-hcdash">
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pa-0">
                      <v-icon color="#3FBC3F" size="30">
                        mdi-clock-time-three-outline
                      </v-icon>
                    </v-col>
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pl-2 pr-0 py-0">
                      <b class="font-cardclock-hcdash">Normal</b>  
                    </v-col> 
                  </v-row>   
                  <v-row justify="end" class="row-page-hcdash mt-2">
                    <b class="font-clocknum-hcdash">{{all_green_count}}</b>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" lg="4" class="pt-0 padding-card-process-waiting-am">
                <v-card elevation="0" class="pl-3 pt-2 pb-0 pr-3 hov-hcdash card-border-color-process-anml" @click='modalnormal("yellow")'>
                  <v-row class="row-page-hcdash">
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pa-0">
                      <v-icon color="#FEA322" size="30">
                        mdi-timer-outline
                      </v-icon>
                    </v-col>
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pl-3 pr-0 py-0">
                      <v-row class="row-page-hcdash">
                        <b class="font-cardclock-hcdash">Monitor</b>
                      </v-row>  
                    </v-col> 
                  </v-row>   
                  <v-row justify="end" class="row-page-hcdash mt-2">
                    <b class="font-clocknum-hcdash">{{all_yellow_count}}</b>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" lg="4" class="pr-0 pt-0 padding-card-process-waiting-al">
                <v-card elevation="0" class="pl-3 pt-2 pb-0 pr-3 hov-hcdash card-border-color-process-anml" @click='modalnormal("red")'>
                  <v-row class="row-page-hcdash">
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pa-0">
                      <v-icon color="#FF0000" size="30">
                        mdi-alarm
                      </v-icon>
                    </v-col>
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pl-3 pr-0 py-0">
                      <v-row class="row-page-hcdash">
                        <b class="font-cardclock-hcdash">Alarm</b>
                      </v-row>  
                    </v-col> 
                  </v-row>   
                  <v-row justify="end" class="row-page-hcdash mt-2">
                    <b class="font-clocknum-hcdash">{{all_red_count}}</b>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" lg="6" class="pr-0 py-0 padding-right-second">
          <v-card class="border-radius-cardall pt-2 pb-3 px-3 border-radius-process" color="#FFFFFF" elevation="0">
            <v-row class="row-page-hcdash font-on-process">
              <b class="mr-1">On Process (P)</b> Waiting Performance Payment Status
            </v-row>
            <v-row class="row-page-hcdash">
              <v-col cols="12" md="4" lg="4" class="pl-0 pt-0 padding-card-process-waiting-an">
                <v-card elevation="0" class="pl-3 pt-2 pb-0 pr-3 hov-hcdash card-border-color-process-panml" @click='modalnormal("green_p")'>
                  <v-row class="row-page-hcdash">
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pa-0">
                      <v-icon color="#3FBC3F" size="30">
                        mdi-clock-time-three-outline
                      </v-icon>
                    </v-col>
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pl-4 pr-0 py-0">
                      <v-row class="row-page-hcdash">
                        <b class="font-cardclock-hcdash">Normal</b>
                      </v-row>  
                    </v-col> 
                  </v-row>   
                  <v-row justify="end" class="row-page-hcdash mt-2">
                    <b class="font-clocknum-hcdash">{{all_green_p_count}}</b>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" lg="4" class="pt-0 padding-card-process-waiting-am">
                <v-card elevation="0" class="pl-3 pt-2 pb-0 pr-3 hov-hcdash card-border-color-process-panml" @click='modalnormal("yellow_p")'>
                  <v-row class="row-page-hcdash">
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pa-0">
                      <v-icon color="#FEA322" size="30">
                        mdi-timer-outline
                      </v-icon>
                    </v-col>
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pl-4 pr-0 py-0">
                      <v-row class="row-page-hcdash">
                        <b class="font-cardclock-hcdash">Monitor</b>
                      </v-row>  
                    </v-col> 
                  </v-row>   
                  <v-row justify="end" class="row-page-hcdash mt-2">
                    <b class="font-clocknum-hcdash">{{all_yellow_p_count}}</b>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" lg="4" class="pr-0 pt-0 padding-card-process-waiting-al">
                <v-card elevation="0" class="pl-3 pt-2 pb-0 pr-3 hov-hcdash card-border-color-process-panml" @click='modalnormal("red_p")'>
                  <v-row class="row-page-hcdash">
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pa-0">
                      <v-icon color="#FF0000" size="30">
                        mdi-alarm
                      </v-icon>
                    </v-col>
                    <v-col align-self="center" cols="auto" md="auto" lg="auto" class="pl-4 pr-0 py-0">
                      <v-row class="row-page-hcdash">
                        <b class="font-cardclock-hcdash">Alarm</b>
                      </v-row>  
                    </v-col> 
                  </v-row>   
                  <v-row justify="end" class="row-page-hcdash mt-2">
                    <b class="font-clocknum-hcdash">{{all_red_p_count}}</b>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <div v-show="show_table">
      <v-row class="row-page-hcdash mt-4 mb-4">
        <v-col align-self="center" cols="12" md="3" lg="3"  class="padding-date-hcdash pt-0 pb-date-hcdash">
        <b class="font-subti-hcdash">Petty Cash Information Table</b></v-col>
        <v-spacer class="display-pc-only"></v-spacer>
        <v-col align-self="center" cols="12" md="3" lg="3"  class="padding-date-hcdash pt-0 pb-date-hcdash">
            <v-menu ref="menutable" v-model="menutable" :close-on-content-click="false" 
              :return-value.sync="datetable"
              offset-y
              max-width="290"
              nudge-top="-8"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="datefilterTable"
                  v-on="on"
                  readonly
                  dense solo flat hide-details color="#9a9a9a" height="40"
                  class="rounded-lg font-date-hcdash" background-color="white"
                  append-icon="mdi-chevron-down"
                ></v-text-field>
              </template>
              <v-date-picker v-model="datetable" range no-title show-current :max="currentdate" color="#1DBC97">
                <v-spacer></v-spacer>
                <v-btn height="32" outlined color="#1DBC97" class="rounded-lg font-cleacon-hcdash" @click="menutable = false,clearDateTable()">
                  Clear
                </v-btn>
                <v-btn height="32" :disabled="datetable.length < 2" depressed color="#1DBC97" class="white--text rounded-lg font-cleacon-hcdash" @click="$refs.menutable.save(datetable),report_table_body(),changeDateTable()">
                  Confirm
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
      </v-row> 
      <v-card elevation="0" class="mb-8 py-6 px-5 rounded-xl" color="#FFFFFF">
        <v-data-table
            class="height-data-table-hcdash data-table-header-hcdash data-table-text-hcdash data-table-border-hcdash"
            fixed-header
            :headers="report_table_header"
            :items="hc_report_data"
            :footer-props="{'items-per-page-options': [5, 10, 15]}"
          >
          </v-data-table>
      </v-card>
      </div>
      <HCDashboardDetailModal @RefreshAllDoc="countHcDashboard" @RefreshWPS="report_table_body"/>
      <HcDashboardAddPermission @send-data="getUsersData"/>
      <HcDashboardAddDoctype/>
    </div>
</template>

<script>

import { EventBus } from '../../EventBus'
import HCDashboardDetailModal from './HCDashboardDetailModal.vue'
import HcDashboardAddPermission from './HcDashboardAddPermission.vue'
import HcDashboardAddDoctype from '../../components/HcDashboardAddDoctype.vue'

import moment from 'moment'
  export default {
    data: () => ({
      downloading:false,
      allhcdashboard: [
        {
          "remark": "ทั้งหมด 17 บริษัท",
          "_id": "",
          "tax_id": ""
        }],
      allTaxId: [],
      menutable: false,
      menu: false,   
      date: [(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)],
      datetable: [(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)],
      currentdate: new Date().toISOString().substr(0, 10),
      dateText: "",
      datefilterTable:"",
      dateAllFilter:"",
      hc_report_data:[],
      all_count: 0,
      ap_count:  0,
      paid_count:0,
      accept_count:  0,
      decline_count: 0,
      approve_count: 0,
      wait_paid_count: 0,
      prepare_count: 0,
      review_count:  0,
      reject_count:  0,
      cancel_count:  0,
      all_green_count:  0,
      all_yellow_count: 0,
      all_red_count: 0,
      all_green_p_count:  0,
      all_yellow_p_count: 0,
      all_red_p_count: 0,
      document_type_id: "",
      page_status_all_document:true,
      total_paid:0,
      total_waitpaid:0,
      user_account_id: "",
      company_name: "",
      manager_account_id: [
        "410697594368", 
        "50214806880",
        "41603107788896200",
        "6338003248", 
        //-- od 
        "343414252239782",
        "1561609220",
        "6217412328",
        "10614244390462915",
        "1326589858466075" //on
      ],
      is_manager_account_id: false,
      data_table_items : [],
      button_select_biz : false,
      user_email: "",
      show_table : true
    }),
    //---------------------------- Computed ----------------------------//
    computed:{
      report_table_header() {
        return [
          { text: 'Date', align: 'center', sortable: true, value: 'date_string',},
          { text: 'New Document', align: 'center', sortable: true, value: 'new_document' },
          { text: 'Prepare', align: 'center', sortable: true, value: 'prepare' },
          { text: 'Reject', align: 'center', sortable: true, value: 'reject' },
          { text: 'Cancel', align: 'center', sortable: true, value: 'cancel' },
          { text: 'Approved', align: 'center', sortable: true, value: 'approved' },
          // { text: 'Balance', align: 'center', sortable: true, value: 'balance' },
          { text: 'On Process (A)', align: 'center', sortable: true, value: 'balance' },
          // { text: 'ตั้งหนี้', align: 'center', sortable: true, value: 'ap' },
          { text: 'จ่ายแล้ว', align: 'center', sortable: true, value: 'paid' },
          // { text: 'Balance', align: 'center', sortable: true, value: 'balance_ap' },
          { text: 'On Process (P)', align: 'center', sortable: true, value: 'balance_ap' },
          { text: 'ยืนยันรับเงิน', align: 'center', sortable: true, value: 'accept' },
          { text: 'ปฏิเสธรับเงิน', align: 'center', sortable: true, value: 'decline' }
        ]
      }
    },
    //---------------------------- Mounted ----------------------------//
    mounted () {
      this.countReportHcDashboard()
      this.report_table_body()
      this.countHcDashboard()
      this.amount_paid()
      this.amount_waitpaid()
      this.getHcDashboardAddDoctype()
      this.get_hc_jv_doctype()
      let tempDate = this.date
      let tempDateTable = this.datetable
      tempDate.sort((a, b) => (new Date(a).getTime() > new Date(b).getTime()) ? 1 : -1)
      tempDateTable.sort((a, b) => (new Date(a).getTime() > new Date(b).getTime()) ? 1 : -1)
      this.dateText = `${this.setDateFormatBEShort(new Date(tempDate[0]).toISOString().substr(0,10))} - ${this.setDateFormatBEShort(new Date(tempDate[1]).toISOString().substr(0,10))}`,
      this.datefilterTable =`${this.setDateFormatBEShort(new Date(tempDateTable[0]).toISOString().substr(0,10))} - ${this.setDateFormatBEShort(new Date(tempDateTable[1]).toISOString().substr(0,10))}`,
      this.user_account_id = JSON.parse(sessionStorage.getItem("userProfile")).id
      this.user_email = JSON.parse(sessionStorage.getItem("userProfile")).thai_email
      this.isManagerAccountID()
    },
    //---------------------------- Methods ----------------------------//
    methods: {
      isManagerAccountID(){
        const is_managers = (this.manager_account_id.map((account_id) => account_id === this.user_account_id))
        this.is_manager_account_id = is_managers.some(i => i)
      },
      modalnormal(status) {
        var cout_doc = 0
        var page_all_doc = false
        if(status == 'green'){
          cout_doc = this.all_green_count
        }else if(status == 'yellow'){
          cout_doc = this.all_yellow_count
        }else if(status == 'red'){
          cout_doc = this.all_red_count
        }else if(status == 'green_p'){
          cout_doc = this.all_green_p_count
        }else if(status == 'yellow_p'){
          cout_doc = this.all_yellow_p_count
        }else if(status == 'red_p'){
          cout_doc = this.all_red_p_count
        } else if(status == 'prepare'){
          cout_doc = this.prepare_count
          page_all_doc = this.page_status_all_document
        }else if(status == 'review'){
          cout_doc = this.review_count
          page_all_doc = this.page_status_all_document
        }else if(status == 'reject'){
          cout_doc = this.reject_count
          page_all_doc = this.page_status_all_document
        }else if(status == 'cancel'){
          cout_doc = this.cancel_count
          page_all_doc = this.page_status_all_document
        }else if(status == 'approved'){
          cout_doc = this.approve_count
          page_all_doc = this.page_status_all_document
        }else if(status == 'wait_paid'){
          cout_doc = this.wait_paid_count
          page_all_doc = this.page_status_all_document
        }else if(status == 'paid'){
          cout_doc = this.paid_count
          page_all_doc = this.page_status_all_document
        }else if(status == 'accept'){
          cout_doc = this.accept_count
          page_all_doc = this.page_status_all_document
        }else if(status == 'decline'){
          cout_doc = this.decline_count
          page_all_doc = this.page_status_all_document
        }
        EventBus.$emit('formhcdashboarddetailmodal',status,cout_doc,page_all_doc,this.dateAllFilter)
      },
      addPermission() {
        EventBus.$emit('FormHcDashBoardAddPermission')
      },
      addDoctype() {
        EventBus.$emit('FormHcDashBoardAddDoctype')
      },
      //----- countReportHcDashboard ==> เรียกใช้มาแสดงข้อมูลในหัวข้อ Waiting Performance Status รายละเอียดดังนี้ Green:1-7, Yellow:8-15, Red:>16 ----//
      async countReportHcDashboard() {
        try{
          //var tax_id = sessionStorage.getItem('tax_id')
          var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
          var url = '/petty_cash/api/v1/count_report_hc_dashboard'
          var { data } = await this.axios.post(this.$api_url + url, {
            "keyword":"",
            "tax_id" :tax_id,
            start_date:this.dateAllFilter[0],
            end_date:this.dateAllFilter[1],
          })
          if(data){
            this.all_green_count = data.result.green
            this.all_red_count = data.result.red
            this.all_yellow_count = data.result.yellow
            this.all_green_p_count = data.result.green_p
            this.all_red_p_count = data.result.red_p
            this.all_yellow_p_count = data.result.yellow_p
          }
        }catch(error){
          console.log(error)
        }
      },
      //----- report_table_body ==> เรียกใช้แสดงข้อมูลในตาราง----//
      async report_table_body(){
        this.hc_report_data = []
        try{
          //var tax_id = sessionStorage.getItem('tax_id')
          var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
          var url = '/petty_cash/api/v1/get_report_list'
          var { data } = await this.axios.post(this.$api_url + url, {
            type:"current_month",
            tax_id:tax_id,
            date:this.datetable
          })
          if(data){
            data.result.forEach(element => {
              this.hc_report_data.push(element.detail_table)
            })
          }
        }
        catch(error){
          console.log(error);
        }
      },
      //----- countHcDashboard ==> เรียกใช้แสดงข้อมูลในหัวข้อ All Document----//
      async countHcDashboard(){
        this.downloading = true
        try{
          //var tax_id = sessionStorage.getItem('tax_id')
          var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
          var url = '/petty_cash/api/v1/count_hc_dashboard'
          var { data } = await this.axios.post(this.$api_url + url, {
            "keyword":"",
            "tax_id":tax_id,
            start_date:this.dateAllFilter[0],
            end_date:this.dateAllFilter[1],
          })
          if(data){
            this.all_count = data.result.all_count
            this.ap_count  = data.result.ap_count
            this.paid_count = data.result.paid_count
            this.accept_count  = data.result.accept_count
            this.decline_count = data.result.decline_count
            this.wait_paid_count = data.result.wait_paid_count
            this.approve_count = data.result.approve_count
            this.prepare_count = data.result.prepare_count
            this.reject_count  = data.result.reject_count
            this.review_count  = data.result.wait_count
            this.cancel_count  = data.result.cancel_count
          }
        }catch(error){
          console.log(error)
        }finally{
            this.downloading = false
        }
      },
      //----- exportHcDashboard ==> เรียกใช้ Export Excel ----//
      async exportHcDashboard() {
        try {
          //var tax_id = sessionStorage.getItem('tax_id')
          var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
          var url = '/petty_cash/api/v1/export_report_list'
          var  data  = await this.axios.post(this.$api_url  + url, { type : "current_month", tax_id : tax_id, date:this.date }, { responseType: "blob" })
          .then( response  =>{
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            let namefile = `Report Operation ${moment().locale('th').add(543, 'year').format('DD MMMM YYYY h_mm_ss')}.xlsx`
            link.href = url;
            link.setAttribute("download", namefile);
            document.body.appendChild(link);
            link.click();    
          })
        } catch (error) {
          console.log(error)
        }
      },
      changeDate () {
        let tempDate = this.date
        tempDate.sort((a, b) => (new Date(a).getTime() > new Date(b).getTime()) ? 1 : -1)
        this.dateText = `${this.setDateFormatBEShort(new Date(tempDate[0]).toISOString().substr(0,10))} - ${this.setDateFormatBEShort(new Date(tempDate[1]).toISOString().substr(0,10))}`
        this.dateAllFilter = tempDate
      },
      changeDateTable () {
        let tempDate = this.datetable
        tempDate.sort((a, b) => (new Date(a).getTime() > new Date(b).getTime()) ? 1 : -1)
        this.datefilterTable = `${this.setDateFormatBEShort(new Date(tempDate[0]).toISOString().substr(0,10))} - ${this.setDateFormatBEShort(new Date(tempDate[1]).toISOString().substr(0,10))}`
      },
      // Date Converter
      setDateFormatBEShort (date) {
        var curDate = date.split('-')
        var thaiDate =this.addZero( String(Number(curDate[2]))) + '/' + this.addZero(String(curDate[1])) + '/' + String(Number(curDate[0]) + 543)
        return date ? thaiDate : ''
      },
      //Add Zero to date
      addZero(str) {
        if(str.length == 1) {
            str = `0${str}`
        }
        return str
      },
      formatPrice(price_value){
          var formatted_price = '';
          var price = ''+price_value;
          var price_length = price.length;
          var start;
          while(price_length > 0){
              start = price_length - 3 > 0 ? price_length - 3 : 0;
              formatted_price = ',' + price.substring(start, start+3)+formatted_price;
              price = price.substring(0, start);
              price_length = price.length;
          }
          formatted_price = formatted_price.replace(/,/, '');
          return formatted_price;
      },
      async amount_paid() {
        try {
          //var tax_id = sessionStorage.getItem('tax_id')
          var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
          var url = '/petty_cash/api/v1/amount_paid'
          var { data } = await this.axios.post(this.$api_url + url, {
            status: "paid",
            tax_id:tax_id,
            start_date:this.dateAllFilter[0],
            end_date:this.dateAllFilter[1],
          })
          if(data){
            let value  = data.total_amount.toFixed(2).toString().split('.')
            if(value.length == 1 ){
              let amount = this.formatPrice(value[0])
              this.total_paid = amount
            }else{
              let amount = this.formatPrice(value[0])
              this.total_paid = amount + '.' + value[1]
            } 
          }
          
        } catch (error) {
          console.log(error)
        }
      },
      async amount_waitpaid() {
        try {
          //var tax_id = sessionStorage.getItem('tax_id')
          var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
          var url = '/petty_cash/api/v1/amount_waitpaid'
          var { data } = await this.axios.post(this.$api_url + url, {
            status: "wait_paid",
            tax_id:tax_id,
            start_date:this.dateAllFilter[0],
            end_date:this.dateAllFilter[1],
          })
          if(data){
            let value  = data.total_amount.toFixed(2).toString().split('.')
            if(value.length == 1 ){
              let amount = this.formatPrice(value[0])
              this.total_waitpaid = amount
            }else{
              let amount = this.formatPrice(value[0])
              this.total_waitpaid = amount + '.' + value[1]
            } 
          }
          
        } catch (error) {
          console.log(error)
        }
      },
      async getHcDashboardAddDoctype() {
            try{
                //let tax_id = sessionStorage.getItem('tax_id')
                let tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
                let url = '/petty_cash/api/v1/get_hc_doctype?tax_id=' + tax_id
                let { data } = await this.axios.get(this.$api_url + url, { headers: { Authorization: "Bearer " + sessionStorage.getItem("access_token") } })
                if(data){
                  this.company_name = data.data[0].remark
                } 
            }catch(error){
              this.company_name = this.allhcdashboard[0].remark
              this.show_table = false
              console.log(error)
            }
            finally{
                this.loading = false
            }
      },
      async getAllFuntionApi(data) {
            try{
                await this.setDate()
                this.countHcDashboard()
                this.amount_paid()
                this.amount_waitpaid()
                this.countReportHcDashboard()
                this.report_table_body()
            }catch(error){
                console.log(error)
            }
            finally{
                this.loading = false
            }
      },
      async clearDateAllDocument() {
            try{
              this.dateAllFilter = ''
              this.date = await [
                (new Date(  Date.now() - (new Date()).getTimezoneOffset() * 60000)  ).toISOString().substr(0, 10),
                (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
              ];      
              this.dateText = `${this.setDateFormatBEShort(new Date( Date.now() - (new Date()).getTimezoneOffset() * 60000 ).toISOString().substr(0,10))} - ${this.setDateFormatBEShort(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0,10))}`
              this.countHcDashboard()
              this.amount_paid()
              this.amount_waitpaid()
              this.countReportHcDashboard()
            }catch(error){
                console.log(error)
            }
            finally{
                this.loading = false
            }
      },
      async clearDateTable() {
            try{
                this.datetable = await [
                    (new Date(  Date.now() - (new Date()).getTimezoneOffset() * 60000)  ).toISOString().substr(0, 10),
                    (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
                ];
                this.datefilterTable = `${this.setDateFormatBEShort(new Date( Date.now() - (new Date()).getTimezoneOffset() * 60000 ).toISOString().substr(0,10))} - ${this.setDateFormatBEShort(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0,10))}`,
                this.report_table_body()
            }catch(error){
                console.log(error)
            }
            finally{
                this.loading = false
            }
      },
      //----- เรียกใช้เพื่อแสดงข้อมูลของ JV ----//
      async get_hc_jv_doctype(){
        this.hc_report_data = []
        try{
          var url = '/petty_cash/api/v1/get_hc_jv_doctype'
          let { data } = await this.axios.get(this.$api_url + url, { headers: { Authorization: "Bearer " + sessionStorage.getItem("access_token") } })
          let allTaxId = []
          let obj = {}
          if(data){
            //this.allhcdashboard = data.data
            for(let i = 0 ; i < data.data.length ; i++){
              this.allhcdashboard.push(data.data[i])
              allTaxId.push(data.data[i].tax_id)
            }
            obj['$in'] = allTaxId
            this.allhcdashboard[0].tax_id = obj
          }
        }
        catch(error){
          console.log(error);
        }
      },
      //----- จัดการ Biz ----//
      async setBiz(tax_id){
        if(typeof tax_id == "string" ){
          this.show_table = true
        }else{
          this.show_table = false
        }
        try{
          if(tax_id){
            sessionStorage.setItem('tax_id', JSON.stringify(tax_id));
            const resultBiz = this.allhcdashboard.find((data) => data.tax_id == tax_id);
            this.company_name = resultBiz.remark
            this.getAllFuntionApi()
          }
        }
        catch(error){
          console.log(error);
        }
      },
    async getUsersData(data) {
      try {
        this.user_email
        //let email = JSON.parse(sessionStorage.getItem("userProfile")).thai_email
        const data_user = data.find(element => element.email == this.user_email );
        if(data_user.role == 'superAdmin' || data_user.role == 'admin'){
          this.button_select_biz = true
        }
      } catch (error) {
        console.log(error);
      }
    },
    async clearSelect() {
      let tax_id = await JSON.parse(sessionStorage.getItem('tax_id_original'));
      if(typeof tax_id == "string" ){
        this.show_table = true
      }else{
        this.show_table = false
      }
      await sessionStorage.setItem('tax_id', JSON.stringify(tax_id));
      await this.getHcDashboardAddDoctype()
      await this.getAllFuntionApi()
    },
    async setDate() {
      //----- เวลา All Document -----//
      this.dateAllFilter = ''
      this.date = await [
        (new Date(  Date.now() - (new Date()).getTimezoneOffset() * 60000)  ).toISOString().substr(0, 10),
        (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      ];      
      this.dateText = `${this.setDateFormatBEShort(new Date( Date.now() - (new Date()).getTimezoneOffset() * 60000 ).toISOString().substr(0,10))} - ${this.setDateFormatBEShort(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0,10))}`,
      //----- เวลา Petty Cash Information Table -----//
      this.datetable = await [
        (new Date(  Date.now() - (new Date()).getTimezoneOffset() * 60000)  ).toISOString().substr(0, 10),
        (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      ];
      this.datefilterTable = `${this.setDateFormatBEShort(new Date( Date.now() - (new Date()).getTimezoneOffset() * 60000 ).toISOString().substr(0,10))} - ${this.setDateFormatBEShort(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0,10))}`
    }
    },
    //---------------------------- Components ----------------------------//
    components: {
      HCDashboardDetailModal,
      HcDashboardAddPermission,
      HcDashboardAddDoctype
    }
  }
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Thai&display=swap');
.pd-select-dashboard{
  padding-right: 8px;
}

.text-box-hcdashboard-select {
  font-family: 'Noto Sans Thai', sans-serif;
  font-size: 14px !important;
  border-radius: 10px !important;
}
  .row-page-hcdash {
    width: 100%;
    margin: 0% ;
  }

  .btn-bg-export {
    background-color: white !important;
  }

  .hov-hcdash:hover {
    cursor: pointer;
  }

  .border-radius-cardall {
    border-radius: 10px !important;
  }

  .font-numcanreject-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 24px !important;
    color: #333333;
  }

   .font-canreject-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 15px !important;
    color: #333333;
  }

  .font-header-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 24px !important;
    font-weight: 700 !important;
    color: #333333;
  }

  .font-date-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 16px !important;
  }

  .font-cleacon-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 16px !important; 
    text-transform: capitalize !important;
  }

  .font-expoet-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #1DBC97;
  }

  .font-subti-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 18px !important;
    color: #333333;
  }

  .font-cardclock-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 15px !important;
    color: #333333;
  }

  .font-clocknum-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 24px !important;
    color: #333333;
    line-height: 28px !important;
  }

  .font-card-alldoctotal-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 24px !important;
    color: #333333;
  }

  .font-card-numtotala-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 36px !important;
    color: #333333;
    line-height: 28px !important;
  }

  .font-card-title-processa-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 20px !important;
    color: #333333;
  }

  .font-card-processb-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 40px !important;
    color: #333333;
    line-height: 28px !important;
  }

  .font-on-process {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 18px !important;
    color: #333333;
  }

  .font-card-numalldoc-hcdash {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 32px !important;
    color: #333333;
  }

  .padding-date-hcdash {
    padding-left: 0% !important;
    padding-right: 0% !important;
  }

  .padding-header-hcdash {
    padding-left: 2% !important;
    padding-right: 0% !important;
  }

  .padding-card-process-waiting-an {
    padding-right: 1% !important;
    padding-bottom: 0% !important;
  }

  .padding-card-process-waiting-am {
    padding-left: 1% !important;
    padding-right: 1% !important;
    padding-bottom: 0% !important;
  }

  .padding-card-process-waiting-al {
    padding-left: 1% !important;
    padding-bottom: 0% !important;
  }

  .border-radius-alldoc::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 10px; 
    padding: 1px; 
    background:linear-gradient(to right, #4ED4B5 100%, #D4C5F4 100%, #D1EFF8 100%); 
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
  }

  .border-radius-process::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 10px; 
    padding: 1px; 
    background:linear-gradient(to right, #65D9BF 100%, #81CAFA 99%, #D1C2F3 100%); 
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
  }

  .padding-right-first {
    padding-right: 0.5% !important;
  }

  .padding-right-second {
    padding-left: 0.5% !important;
  }

  .card-border-color-total {
    background: linear-gradient(142.58deg, #31CCA9 2.19%, #F9FEFD 82.69%);
    border: 1px solid #D1E8F8 !important;
    border-radius: 10px !important;
  }

  .card-border-color-approved {
    background: linear-gradient(138.37deg, #8AF0D9 7.94%, #98F5E0 70.65%);
    border: 1px solid #D1E8F8 !important;
    border-radius: 10px !important;
    width: 100%;
  }

  .card-border-color-cancelreject {
    background: linear-gradient(0deg, #D9D9D9 0%, #FFFFFF 79.51%);
    border: 1px solid #E7E7E7 !important;
    border-radius: 10px !important;
  }

  .card-border-color-process-a {
    background: linear-gradient(160.1deg, #D1C1F2 0.55%, #FFFFFF 90.83%);
    border: 1px solid #D1E8F8 !important;
    border-radius: 10px !important;
  }

  .card-border-color-pay {
    background: linear-gradient(142.58deg, #31CCA9 2.19%, #F9FEFD 82.69%);
    border: 1px solid #D1E8F8 !important;
    border-radius: 10px !important;
  }

  .card-border-color-process-p {
    background: linear-gradient(144.31deg, #B9DEF7 15.3%, #FFFFFF 94.15%);
    border: 1px solid #D1E8F8 !important;
    border-radius: 10px !important;
  }
  
  .card-border-color-confirmpay {
    background: linear-gradient(134.46deg, #44DBB8 8.78%, #F9FEFD 84.64%);
    border: 1px solid #D1E8F8 !important;
    border-radius: 10px !important;
    width: 100%;
  }

  .card-border-color-cancelpay {
    background: linear-gradient(132.77deg, #55DEBF 9.15%, #F9FEFD 84.78%);
    border: 1px solid #D1E8F8 !important;
    border-radius: 10px !important;  
    width: 100%;
  }

  .card-border-color-process-anml {
    background: linear-gradient(142.58deg, #D1C2F3 2.19%, #F9FEFD 82.69%);
    border: 1px solid #D9D8D8 !important;
    border-radius: 10px !important;
  }

  .card-border-color-process-panml {
    background: linear-gradient(142.58deg, #B9DEF7 2.19%, #F9FEFD 82.69%);
    border: 1px solid #D9D8D8 !important;
    border-radius: 10px !important;
  }

  .card-border-color-process-pm {
    background: linear-gradient(130.18deg, #CAE7FB -7.6%, rgba(207, 232, 250, 0.486458) 40.66%, rgba(255, 255, 255, 0) 105.43%);
    border: 1px solid #D1E8F8 !important;
    border-radius: 16px !important;
  }

  .card-border-color-process-pl {
    background: linear-gradient(125.44deg, #DED7F7 10.4%, rgba(238, 234, 251, 0.27) 53.43%, rgba(255, 255, 255, 0) 99.62%);
    border: 1px solid #D1E8F8 !important;
    border-radius: 16px !important;
  }

  .padding-right-total {
      padding-right: 1% !important;
  }

  .padding-left-right-process {
    padding-left: 1% !important;
      padding-right: 1% !important;
  }

  .padding-box-left-total {
      padding-left: 1% !important;
      padding-top: 0% !important;
  }

  .padding-top-processa {
    padding-top: 0% !important;
  }

  /* .padding-box-left-inrow {
    padding-bottom: 4% !important;
  } */

  /*table*/

  .height-data-table-hcdash.v-data-table > .v-data-table__wrapper {
    height: calc(100vh - 500px);
    overflow: auto;
  }

  .data-table-header-hcdash.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
    box-shadow: none !important;
    height: 40px !important;
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 16px !important  ;
    font-weight: 500 !important;
    color: #333333 !important;
    background: #F8F8FD;
  }

  .theme--light .data-table-text-hcdash.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row) {
    border-bottom: 1px solid #f3f5f7 !important;
  }

.data-table-text-hcdash.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
    height: 40px !important;
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 14px !important ;
    color: #333333 !important;
  }  

  .data-table-border-hcdash .v-data-table__wrapper {
    border: 1px solid #f3f5f7;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  } 

  .data-table-border-hcdash.theme--light.v-data-table .v-data-footer {
    border: 1px solid #f3f5f7;
    margin-right: 0% !important;
    border-bottom-left-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
  }

  .margin-top-numtotal {
    margin-top: 61px !important;
  }

  .magin-top-numprocessa {
    margin-top: 74px !important;
  }

  .margin-top-numpaid {
    margin-top: 51px !important;
  }

  .margin-top-numprocessp {
    margin-top: 57px !important;
  }

  .font-totalpay-hcdash {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 12px !important ;
    color: #333333 !important;
  }

  .border-cardincard1-hcdash {
    background: #F9FEFD !important;
    border: 1px solid #30CBA8 !important;
    border-radius: 8px !important;
  }

  .border-cardincard2-hcdash {
    background: #F5FBFE !important;
    border: 1px solid #4FA0D7 !important;
    border-radius: 8px !important;
  }
  .pb-date-hcdash{
    padding-bottom: 0px !important;
  }

  /*========================================*/

  @media only screen and (max-width:600px){ /*css for mobile screen*/
    .text-box-hcdashboard-select {
  font-size: 12px !important;
}
    .pd-select-dashboard{
      padding-right: 0px;
      padding-left: 0px;
    }

    .height-data-table-hcdash.v-data-table > .v-data-table__wrapper {
      max-height: calc(100vh - 175px);
    }
    .pb-date-hcdash{
    padding-bottom: 12px !important;
  }
    .padding-header-hcdash {
      margin-left: auto;
    }

    .padding-card-process-waiting-an {
      padding-right: 0% !important;
      padding-bottom: 3% !important;
    }

    .padding-card-process-waiting-am {
      padding-left: 0% !important;
      padding-right: 0% !important;
      padding-bottom: 3% !important;
    }

    .padding-card-process-waiting-al {
      padding-left: 0% !important;
    }

    .padding-right-first {
      padding-right: 0% !important;
    }

    .padding-right-second {
      padding-left: 0% !important;
      margin-top: 3% !important;
    }

    .padding-right-total {
      padding-right: 0% !important;
    }

    .padding-box-left-total {
      padding-left: 0% !important;
      padding-top: 3% !important;
    }

    .padding-left-right-process {
      padding-left: 0% !important;
      padding-right: 0% !important;
    }

    .padding-top-processa {
      padding-top: 3% !important;
    }

    /* .padding-box-left-inrow {
      padding-bottom: 5% !important;
    } */
    .pt-header-hc {
    padding-left: 0% !important;
    padding-right: 0% !important;
    margin-left: 0% !important;
  }
  }

</style>
